export const naviListData = [
  {
    name: 'Statement',
    link: '/statement',
    type: 'ja',
  },
  {
    name: 'Jugglers',
    link: '/jugglers',
    type: 'ja',
  },
  {
    name: 'Statement',
    link: '/eng/statement',
    type: 'eng',
  },
  {
    name: 'Jugglers',
    link: '/eng/jugglers',
    type: 'eng',
  },
];

/****************** */

export const aokiJugglerData = {
  jugglerName: '青木直哉',
  title: ['Stay Home'],
  topPicUrl: 'https://static.juggling-mstdn.net/jodo/jugglers/aoki.jpg',
  date: ['2020/5/9(土) 14:00-', '2020/5/10(日) 14:00-'],
  venue: '横浜 某所',
  props: 'ディアボロ',
  descTitle: '家とディアボロ、視点の実験',
  descDetail: [
    `今回のピンとくるくる浄土には、オンライン配信で参加します。家から繋ぐとなると、空間は狭いし、ライトも自由はそれほど効かないし、音響もそれほどいいわけではありません。消防車なんか通ったら、何にも聞こえないでしょう。その消防車がアパートの目の前で止まったら、演技どころではなくなるでしょう。
  狭い空間を舞台にするにはどうしたらいいのか。生で見る演技よりも、映像で見る方が面白くなるとしたら、それはどういう視点を用意したときか。その遊び方を考えてみました。`,
  ],
  videoId: '',
  profile: [
    {
      name: '青木直哉',
      detail:
        '旅とジャグリングの雑誌 : PONTE編集長。1000日間毎日ディアボロで何かする、という企画がInstagram(@jugglernao) で進行中。2017年11月に始まり、2020年7月に終了予定。',
    },
  ],
};

export const kusuhiJugglerData = {
  jugglerName: 'クスヒ',
  title: ['安定と', '不安定さ'],
  topPicUrl: 'https://static.juggling-mstdn.net/jodo/jugglers/kusuhi.jpg',
  date: ['2020/5/9(土) 16:00-', '2020/5/10(日) 16:00-'],
  venue: '浄土複合 2F',
  props: 'シガーボックス',
  descTitle: '直方体とわたしの退屈さの中で',
  descDetail: [
    'シガーボックスというジャグリング道具は、直方体の形をしていて、ジャグリング道具には数少ない”直角”と”直線”を持っています。また、短辺と長辺を持ち、非対称的な形状をしています。これらの幾何学的な性質から由来する動きに私は強く魅力を感じ、長い間追求してきました。',
    'しかし、最近、それに飽きました。飽きてしまいました。シガーボックスでコネコネ遊んでいると面白い動きをたまに発見するのですが、「面白い!」と思うと同時に「(´・_・｀)...」とも感じるようになりました。さあどうしましょう。',
    '色々悩んだ末、私はこの退屈さを、変化を求める段階に来た証だと無理やり好意的に捉え、今一度自分のシガーボックスジャグリングを見直すことにしました。今のところ、前途多難です。(´・_・｀)です。',
    'しかし、捨てる、という選択肢は今のところ考えておりません。飽きたとはいえ、やはり私は自分なりの直方体の見方を信頼しているようです。',
  ],
  videoId: '',
  profile: [
    {
      name: 'クスヒ',
      detail: '神戸大学JUG六出身。大学入学と同時にジャグリングを始める。',
    },
  ],
};

export const sakatokuJugglerData = {
  jugglerName: '酒德波和',
  title: ['Halo Juggling', 'Rings', 'in Kyoto'],
  topPicUrl: 'https://static.juggling-mstdn.net/jodo/jugglers/sakatoku.jpg',
  date: ['2020/5/9(土) 16:00-', '2020/5/10(日) 16:00-'],
  venue: '浄土複合 2F',
  props: 'リング',
  descTitle: 'アメリカで出逢ったとある半透明のリング',
  descDetail: [
    'ここはIJA会場。語学留学のために単身アメリカで暮らしていた私は初めて触れる世界のジャグリングにとにかく圧倒されます。日本のジャグリングの違いに驚いたり、共通点を見つけて感動したり…。そんな冒険の中で偶然見つけたのはとある半透明のリング。誰の目にも留まるような派手な見た目ではないものの、なぜか私には強く惹きつけるものを感じました。',
    '今回のアクトはこのリングとの出会いを描いたものです。観客として何度も足を運んだピントクルに今回出演する機会をいただき、学生大会のように大勢の観客に自分の強みを誇示する派手なジャグリングではなく、浄土複合という小さくかつ特殊な空間でしかできない、演者も観客も肩の力を抜けるゆるいジャグリングができないかと考えた時、IJA会場での経験を思い出しました。',
    'アメリカで感じた言葉にできない不安、新しいものに出逢うドキドキを表現できたら…と思います。',
  ],
  videoId: 'xS5og6wKhrc',
  profile: [
    {
      name: '酒德波和',
      detail:
        '1999年生まれ三重県出身。twitter名はぴーたろう。大学入学を機にジャグリングを始める。リングに一途なトスジャグラー。昨年1年ほどのアメリカ留学で、語学勉強の傍ら精力的にジャグリング活動とそれを通した交流を深めた。最近5rカスケードに進捗があった。',
    },
  ],
};

export const someyaJugglerData = {
  jugglerName: '染谷樹',
  title: ['綻ぶ歩幅を', '淡く踏む'],
  topPicUrl: 'https://static.juggling-mstdn.net/jodo/jugglers/someya.jpg',
  date: ['2020/5/9(土) 13:00-', '2020/5/10(日) 13:00-'],
  venue: '浄土複合 1F',
  props: '靴',
  descTitle: '靴を題材として、機能を活かしたジャグリングの可能性を探る',
  descDetail: [
    '「靴」をジャグリングの文脈で扱う。靴は一般的なジャグリング道具と異なり、機能を有したプロダクトである。  特に「履く」という用途は人の営みにおいて欠かせない行為であり、故に靴は物それだけで身体を想起させる力を持つ。それを形状を捉え扱う技術であるジャグリングにのせることで、意図された役割を超えた挙動を引き起こし、躍動する人間を映しだす。',
    '本作では、ジャグリングを通じ靴の上に現れた人間とのコミュニケーションを探る。',
    ' ＿＿＿＿＿ ',
    '　',
    '靴を前にした僕らは、そこに人の姿をみる。  それは子供であり、働き盛りの男性であり、老婆である。 その身体は、姿勢は、捉える人によって違うだろう。  靴はその姿の代理であると同時に、あなたの思考の現し身である。 ',
    '　',
    '＿＿＿＿＿',
  ],
  videoId: '',
  profile: [
    {
      name: '染谷樹',
      detail:
        '1993年生まれ。架空カンパニー あしもと所属。2012年大学入学時にジャグリングと出会い、シガーボックスを始める。現在は物体と⾝体が与えるイメージと記憶のあり⽅に関⼼を抱き、靴や木枠といった⽇⽤品を扱った実験的なジャグリングも試みている。',
    },
    {
      name: '架空カンパニー あしもと',
      detail:
        '「人の意思は足元に宿る、物語は足元から始まる」を掲げ活動するジャグリングカンパニー。⽇常から半歩外れた挙動であるジャグリングの、その物体と⾝体の異質で奇怪な関係性を利用し、⼈々の記憶を変質させる作品をつくる。',
    },
  ],
};

export const hyakutoriJugglerData = {
  jugglerName: '百通りファクトリー（小澤駿弥、山下湧志朗）',
  title: ['CONSPIRACY', 'THEORY'],
  topPicUrl: 'https://static.juggling-mstdn.net/jodo/jugglers/hyakutori.jpg',
  date: ['2020/5/9(土) 16:00-', '2020/5/10(日) 16:00-'],
  venue: '浄土複合 1F',
  props: 'Toss Cube',
  descTitle: 'かたちと再考するジャグリングのDistance',
  descDetail: [
    'フェルト生地が巻かれた手で握れるぐらいの立方体、TossCube。長崎でひっそりと生まれたその道具を京都のジャグラーが手に入れたこと。',
    '立方体という「かたち」の奥深さに気づいたが彼が、さらに二人のジャグラー、三十個のCubeを呼び寄せ、「かたちと仲良くなる」なかで見つけたジャグリングを発表する。',
  ],
  videoId: 'ZnbNcTAYKss',
  profile: [
    {
      name: '中西みみず',
      detail:
        'Juggling Unit ピントクル代表。京都でジャグリングの実験場を企画したり、作品をつくったりするひとです。',
    },
    {
      name: '小澤駿弥',
      detail:
        '高校生の頃にジャグリングと出会い、大学入学とともにデビルスティックを中心として本格的にジャグリングを始める。京都大道芸倶楽部 Juggling Donuts 所属、現在大学院修士2回生。過去にはJapan Juggling Festival 2019 Championship 決勝進出や、Juggling Unit ピントクル「秘密基地 vol.7」出演など。',
    },
    {
      name: '山下湧志朗',
      detail:
        'Juggling Donuts所属のクラブジャグラー。1995年生まれ。高専在学中の2012年になんとなくジャグリングを始め、大学編入後はサークルに所属し、現在に至る。外部公演への参加は今回が初。道具の形状を活かす技を好み、特にクラブのノックと呼ばれる系統（クラブをクラブで叩く動き）の研究に力を入れている。トスキューブの演技では摩擦を活かした技に注目。',
    },
  ],
};

export const jugglerDatas: { name: string; data: JugglerData }[] = [
  { name: 'aoki', data: aokiJugglerData },
  { name: 'kusuhi', data: kusuhiJugglerData },
  { name: 'sakatoku', data: sakatokuJugglerData },
  { name: 'someya', data: someyaJugglerData },
  { name: 'hyakutori', data: hyakutoriJugglerData },
];

export const initialJugglerData: JugglerData = {
  jugglerName: '',
  title: [''],
  topPicUrl: '',
  date: [''],
  venue: '',
  props: '',
  descTitle: '',
  descDetail: [''],
  videoId: '',
  profile: [{ name: '', detail: '' }],
};

/***************************** */

export const cardData = [
  {
    name: '青木直哉',
    picUrl: 'https://static.juggling-mstdn.net/jodo/jugglers/aoki.jpg',
    detailUrl: '/jugglers/aoki',
  },
  {
    name: 'クスヒ',
    picUrl: 'https://static.juggling-mstdn.net/jodo/jugglers/kusuhi.jpg',
    detailUrl: '/jugglers/kusuhi',
  },
  {
    name: '酒德波和',
    picUrl: 'https://static.juggling-mstdn.net/jodo/jugglers/sakatoku.jpg',
    detailUrl: '/jugglers/sakatoku',
  },
  {
    name: '染谷樹',
    picUrl: 'https://static.juggling-mstdn.net/jodo/jugglers/someya.jpg',
    detailUrl: '/jugglers/someya',
  },
  {
    name: '百通りファクトリー',
    picUrl: 'https://static.juggling-mstdn.net/jodo/jugglers/hyakutori.jpg',
    detailUrl: '/jugglers/hyakutori',
  },
];

export const cardDataEng = [
  {
    name: 'Aoki Naoya',
    picUrl: 'https://static.juggling-mstdn.net/jodo/jugglers/aoki.jpg',
    detailUrl: '/jugglers/aoki',
  },
  {
    name: 'Kusuhi',
    picUrl: 'https://static.juggling-mstdn.net/jodo/jugglers/kusuhi.jpg',
    detailUrl: '/jugglers/kusuhi',
  },
  {
    name: 'Sakatoku Hawa',
    picUrl: 'https://static.juggling-mstdn.net/jodo/jugglers/sakatoku.jpg',
    detailUrl: '/jugglers/sakatoku',
  },
  {
    name: 'Someya Tatsuru',
    picUrl: 'https://static.juggling-mstdn.net/jodo/jugglers/someya.jpg',
    detailUrl: '/jugglers/someya',
  },
  {
    name: ' One Hundreds Factory',
    picUrl: 'https://static.juggling-mstdn.net/jodo/jugglers/hyakutori.jpg',
    detailUrl: '/jugglers/hyakutori',
  },
];

/******************************* */
export type JugglerData = {
  jugglerName: string;
  title: string[];
  topPicUrl: string;
  date: string[];
  venue: string;
  props: string;
  descTitle: string;
  descDetail: string[];
  videoId: string;
  profile: { name: string; detail: string }[];
};
